import Vue from 'vue';
import Vuex from 'vuex';

// Dynamic Modules
import { IDashModule } from '@/modules/common/store/DashModule';
import {
  UIModuleType,
  UIStoreModule
} from '@/modules/common/store/UIModule/module';
import { TradeState } from '@/modules/trade/store/trade';
import { PortfolioStoreModule } from '@/store/modules/PortfolioModule/module';
import { InvestmentsStoreModule } from '@/modules/wealth/store/investments/module';

// Static Modules
import { CustomerStoreModule } from '@/modules/common/store/CustomerModule/module';
import { FeatureFlagsStoreModule } from '@/modules/common/store/FeatureFlagsModule/module';
import setUserDatadogRum from '@/plugins/datadog-rum';
import { RedeemStoreModule } from '@/modules/wealth/store/redeem/module';
import { FilterModule } from '@/modules/wallet-builder/src/store/filter/module';

Vue.use(Vuex);
const datadogSetUserPlugin = setUserDatadogRum();

export interface IRootState {
  dashModule: IDashModule;
  CustomerModule: CustomerStoreModule;
  tradeModule: TradeState;
  FeatureFlagsModule: FeatureFlagsStoreModule;
  PortfolioModule: PortfolioStoreModule;
  UIModule: UIModuleType;
  InvestmentsModule: InvestmentsStoreModule;
  RedeemModule: RedeemStoreModule;
}

export default new Vuex.Store<IRootState>({
  modules: {
    CustomerModule: CustomerStoreModule,
    FeatureFlagsModule: FeatureFlagsStoreModule,
    PortfolioModule: PortfolioStoreModule,
    UIModule: UIStoreModule,
    InvestmentsModule: InvestmentsStoreModule,
    RedeemModule: RedeemStoreModule,
    FilterModule
  },
  plugins: [datadogSetUserPlugin]
});
